var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplePills(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4951 6.04932C16.0307 4.30413 13.4289 4.07649 11.6837 5.54088L8.34819 8.33969L5.01269 11.1385C3.26751 12.6029 3.03987 15.2047 4.50426 16.9499C5.96865 18.6951 8.5705 18.9227 10.3157 17.4584L16.9866 11.8607C18.7318 10.3964 18.9595 7.7945 17.4951 6.04932ZM10.7998 4.48757C13.1267 2.53506 16.5959 2.83857 18.5484 5.16549C20.5009 7.49241 20.1974 10.9616 17.8705 12.914L11.1995 18.5117C8.87261 20.4642 5.40347 20.1607 3.45095 17.8338C1.49844 15.5068 1.80195 12.0377 4.12886 10.0852L10.7998 4.48757Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58154 9.99313C8.87241 9.74907 9.30605 9.78701 9.55011 10.0779L12.1798 13.2119C12.4239 13.5028 12.386 13.9364 12.0951 14.1805C11.8042 14.4245 11.3706 14.3866 11.1265 14.0957L8.49679 10.9617C8.25273 10.6708 8.29068 10.2372 8.58154 9.99313Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplePills);
export default __webpack_public_path__ + "static/media/temple-pills.30086b498f488c127ef01d19a3bdb26e.svg";
export { ForwardRef as ReactComponent };